import { MainContainer } from "components/shared";
import { SettingLayout } from "layouts/SettingLayout";
import { InnerOptions } from "../InnerOptions";
import { Box } from "components/ui/Box";
import { UpdateForm } from "./UpdateForm";
import { useErrorHandler } from "exceptions/ErrorHandler";
import { useParams } from "react-router-dom";
import { useQuery, useQueryClient } from "react-query";
import { useHubVehicle } from "hooks/api";
import { useEffect } from "react";
import { Documents } from "./Documents";
import { InHomolog } from "utils/InHomolog";

export const HubUpdateVehicle: React.FC = () => {
  const { options } = InnerOptions();
  const { id } = useParams<{ id: string }>();
  const { errorHandler } = useErrorHandler();
  const { getVehicle, getListVehicleDocs } = useHubVehicle();
  const queryClient = useQueryClient();

  const { data } = useQuery({
    queryKey: ["getVehicle", id],
    queryFn: () => getVehicle(id),
    enabled: !!id,
    onError: errorHandler,
  });

  const { data: docs = [] } = useQuery({
    queryKey: ["getListVehicleDocs", { vehicle_id: id }],
    queryFn: () => getListVehicleDocs({ vehicle_id: id }),
    enabled: !!id,
    onError: errorHandler,
  });

  useEffect(() => {
    return () => {
      queryClient.removeQueries(["getVehicle", id]);
      queryClient.removeQueries(["listVehicleBrand"]);
      queryClient.removeQueries(["listVehicleModel"]);
      queryClient.removeQueries(["listVehicleType"]);
    };
  }, [id, queryClient]);

  return (
    <MainContainer>
      <InHomolog />
      <SettingLayout options={options}>
        <Box>
          <UpdateForm data={data} />
        </Box>

        <Documents docs={docs} vehicleId={id} />
      </SettingLayout>
    </MainContainer>
  );
};
